import * as ralColors from '../assets/ral.json'


export function getAsset(url) {
    return `http://127.0.0.1:8000/storage/${url}`
}


export function getRalColorsOptions() {
    return Object.keys(ralColors)
        .map(k => {
            const color = ralColors[k]
            if(!color?.color)
                return null
            return {
                label: `RAL ${color.code} - ${color.names?.en}`,
                value: color.code,
                color: color.color?.hex,
            }
        })
        .filter(o => o)
}
